// Animate existing content surfaces, never an ancestor of fixed navigation,
// filters or sidebars. Keeping the DOM unchanged also preserves Arena fitting.
export const PAGE_ENTRANCE_TARGETS = [
  ':scope > .arena-screen .arena-stage',
  ':scope > .arena-screen .token-rail:not(.has-heading)',
  ':scope > .arena-screen .token-rail.has-heading > ul',
  ':scope > .arena-screen .token-rail.has-heading > .rail-arrival',
  ':scope > .explore-screen .explore-grid',
  ':scope > .explore-screen .explore-empty',
  ':scope > .explore-screen .explore-more',
  ':scope > .explore-screen .explore-board > .explore-filters',
  ':scope > .explore-screen > .explore-rail',
  ':scope > .points-host .rd-points-content',
  ':scope > .leaderboard-stage',
  ':scope > .app-shell > .inner-page',
].join(',');

const initialEntrances = new Set(['card-swap', 'explore-enter', 'queue-enter']);

export function startPageEntrance(root: HTMLElement) {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) return () => {};

  // Snapshot only the mounted page. Later rounds/rows retain their own motion.
  const targets = root.querySelectorAll<HTMLElement>(PAGE_ENTRANCE_TARGETS);
  const animations: Animation[] = [];
  for (const target of targets) {
    for (const animation of target.getAnimations({ subtree: true })) {
      if (
        'animationName' in animation &&
        initialEntrances.has(String(animation.animationName))
      )
        animation.cancel();
    }
    const animation = target.animate(
      [
        { opacity: 0, translate: '0 18px', filter: 'blur(8px)' },
        { opacity: 1, translate: 'none', filter: 'none' },
      ],
      { duration: 480, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'none' },
    );
    animation.id = 'page-entrance';
    animations.push(animation);
  }
  // Show focused/clicked content immediately; don't measure a moving Points
  // list when its floating collapse control is opened or the user scrolls.
  const cancel = () => animations.forEach((animation) => animation.cancel());
  const interactions = ['focusin', 'pointerdown', 'touchstart', 'wheel'];
  for (const event of interactions)
    root.addEventListener(event, cancel, { capture: true, passive: true });
  window.addEventListener('scroll', cancel, { passive: true });
  reduced.addEventListener('change', cancel);
  return () => {
    cancel();
    for (const event of interactions)
      root.removeEventListener(event, cancel, { capture: true });
    window.removeEventListener('scroll', cancel);
    reduced.removeEventListener('change', cancel);
  };
}
